import { hasBuildingRoadAccess, isAutoRoadGround, planBuildingAccess } from '../autoroads.ts';
import { alliedWith, Phase, Terrain } from '../types.ts';
import type { World } from '../world.ts';
import { rebuildFlows } from './pathing.ts';

/** Basic access is included with a finished building, including older towns. */
export function stepAutoRoads(w: World): number {
  if (w.tick % 30 !== 0 || w.phase !== Phase.Build || w.campaign || w.battle
    || w.battleHold || w.gameOver || w.pendingEvent) return 0;

  let paved = 0;
  const b = w.buildings, m = w.map;
  // Stable slot order and a saved tick schedule keep backfilling identical in
  // live games, replays and loaded saves. Connected buildings are cheap to skip;
  // blocked plots are retried so a later gate, bridge or clearing can help them.
  for (let i = 0; i < b.slots.high; i++) {
    if (!b.isAlive(i) || b.build[i] < 1 || !alliedWith(b.team[i], w.wallTeam)
      || hasBuildingRoadAccess(w, i)) continue;
    // The first household establishes the first street to the Hearth. The
    // Hearth alone has no other destination and needs no wilderness search.
    if (i === w.hearth) continue;
    for (const k of planBuildingAccess(w, i)) {
      if (m.terrain[k] === Terrain.Road || !isAutoRoadGround(w, k)) continue;
      m.terrain[k] = Terrain.Road;
      paved++;
    }
  }
  if (paved > 0) {
    m.terrainVersion++;
    // Roads change route costs across the town. Publish this batch together:
    // keeping old sliced fields here would steer a running game differently
    // from a save loaded against the finished road network.
    rebuildFlows(w);
    w.paths.reset();
    w.dirty.districts = true;
  }
  return paved;
}
